import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTheme } from "styled-components";
import {
  DashboardIcon,
  ArrowLeftIcon,
  MarketplaceIcon,
  IconLock,
  SidebarResearchIcon,
  CreateStrategiesIcon,
} from "assets/icons";
import { isChildRoute, hasFreeOrCore } from "utils";
import { useNavigation } from "utils/navigate";
import { Button } from "components/Button";
import { Tooltip } from "components/Tooltip";
import LocationPath from "hooks/locationPath";
import { DASHBOARD_PATH } from "features/Dashboard/routes";
import { MARKETPLACE_V2_PATH } from "features/Explore/routes";
import { STRATEGY_V2_PATH } from "features/Strategy/routes";
import { MARKET_V2_PATH } from "features/Market/routes";
import { RESEARCH_PATH } from "features/Research/routes";
import { useConnectedAccounts } from "features/Dashboard/hook/useConnectedAccounts";
import MultiStepModal from "shared/Modal/SnaptradeModal/MultiStepModal";
import { ChoosePlanModal } from "features/Account/v2/ChoosePlanModal";
import { AppMenuContainer } from "./Sidebar.styles";

export const AppMenu = ({ active = "" }) => {
  const theme = useTheme();
  const collapsed = false;

  const [showBackButton, setShowBackButton] = useState(false);
  // const [isDashboardOpen, setIsDashboardOpen] = useState(false);
  const [showSnaptradeModal, setShowSnaptradeModal] = useState(false);
  const [showPurchasePlanModal, setShowPurchasePlanModal] = useState(false);

  // const { portfolios, isLoading, refetch } = useConnectedAccounts();
  const { refetch } = useConnectedAccounts();

  const {
    navigateToV2,
    navigateToV2StrategyList,
    navigateToV2Marketplace,
    navigateBackToParent,
    navigateToV2Market,
    navigateToV2Research,
  } = useNavigation();

  const handleNavigateToStrategyList = () => {
    // setIsDashboardOpen(false);
    navigateToV2StrategyList();
  };

  const togglePurchasePlanModal = useCallback(() => {
    setShowPurchasePlanModal((prev) => !prev);
  }, []);

  const handlenavigateToV2Marketplace = () => {
    // setIsDashboardOpen(false);
    navigateToV2Marketplace();
  };

  const handleNavigateToParent = () => {
    navigateBackToParent();
  };

  const handleChangePath = useCallback((pathname) => {
    if (isChildRoute(pathname)) {
      /**
       * Dont show back button in sidebar: MVP2-1865
       * Not completely removing whole logic so if we need to revert this
       */
      // setShowBackButton(true);
    } else {
      setShowBackButton(false);
    }
  }, []);

  const handleNavigateToStockSearch = () => {
    // setIsDashboardOpen(false);
    navigateToV2Market();
  };

  const handleNavigateToResearch = () => {
    // setIsDashboardOpen(false);
    navigateToV2Research();
  };

  const toggleSnaptradeModal = () => {
    setShowSnaptradeModal((prevState) => !prevState);
  };

  const BackIcon = () => {
    return (
      <Button
        size="small"
        className="move-back-btn"
        onClick={handleNavigateToParent}
      >
        <ArrowLeftIcon fill="#fff" />
      </Button>
    );
  };

  return (
    <AppMenuContainer>
      <LocationPath changedPath={handleChangePath} />
      <ul>
        {showBackButton && (
          <li className="menu-item active">
            <div className="inner-item" tabIndex={1} role="button">
              {collapsed && (
                <span className="icon-wrapper">
                  <span className="icon">
                    <BackIcon fill={theme.aside.icon.primary} />
                  </span>
                </span>
              )}
              {!collapsed && (
                <span className="item-content mx-0">
                  <Button
                    size="small"
                    className="move-back-btn"
                    width="100%"
                    onClick={handleNavigateToParent}
                  >
                    <ArrowLeftIcon fill="#fff" /> Back
                  </Button>
                </span>
              )}
            </div>
          </li>
        )}

        <li
          className={classNames("menu-item wt-nav-portfolio", {
            active: active.startsWith(DASHBOARD_PATH) || active === "/",
            // open: isDashboardOpen,
          })}
          onClick={() => navigateToV2(DASHBOARD_PATH)}
        >
          <div
            className="inner-item"
            tabIndex={2}
            role="button"
            // onClick={toggleDashboardDropdown}
          >
            <span className="icon-wrapper">
              <span className="icon">
                {!collapsed ? (
                  <DashboardIcon
                    stroke={
                      active.startsWith(DASHBOARD_PATH) || active === "/"
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip value="Dashboard">
                    <DashboardIcon
                      stroke={
                        active.startsWith(DASHBOARD_PATH) || active === "/"
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && (
              <span className="item-content mt-1">
                Dashboard
                {/* <span
                  className={classNames("chevron", { open: isDashboardOpen })}
                >
                  <ChevronDownIcon />
                </span> */}
              </span>
            )}
          </div>
          {/* {!collapsed && isDashboardOpen && (
            <ul className="submenu">
              <li className="submenu-title">All portfolios</li>
              <div className="portfolio-list-container">
                {isLoading ? (
                  <li className="submenu-loading">Loading...</li>
                ) : portfolios && portfolios.length > 0 ? (
                  portfolios.map((account) => {
                    const isSelected = selectedPortfolioIds.includes(
                      String(account.id)
                    );

                    return (
                      <li
                        key={account.id}
                        className={`account-item ${
                          isSelected ? "selected" : ""
                        }`}
                      >
                        <button
                          type="button"
                          onClick={() => handleAccountSelect(account)}
                        >
                          <img
                            src={account.icon}
                            alt={account.broker}
                            className="account-icon"
                          />
                          <Tooltip value={account.nickname} placement="right">
                            <span className="account-broker">
                              {account.nickname}
                            </span>
                          </Tooltip>
                        </button>
                      </li>
                    );
                  })
                ) : (
                  <li className="submenu-empty">No accounts connected</li>
                )}
              </div>
              <li className="account-item">
                <button type="button" onClick={toggleSnaptradeModal}>
                  <PlusCircleIcon />
                  Add an account
                </button>
              </li>
            </ul>
          )} */}
        </li>

        <li
          className={classNames("menu-item wt-nav-marketplace", {
            active: active.startsWith(MARKETPLACE_V2_PATH),
          })}
          onClick={handlenavigateToV2Marketplace}
        >
          <div className="inner-item" tabIndex={3} role="button">
            <span className="icon-wrapper">
              <span className="icon">
                <div className="marketplace-icon">
                  {!collapsed ? (
                    <MarketplaceIcon
                      stroke={
                        active.startsWith(MARKETPLACE_V2_PATH)
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  ) : (
                    <Tooltip value="Market">
                      <MarketplaceIcon
                        stroke={
                          active.startsWith(MARKETPLACE_V2_PATH)
                            ? theme.aside.icon.primary
                            : theme.aside.icon.secondary
                        }
                      />
                    </Tooltip>
                  )}
                </div>
              </span>
            </span>
            {!collapsed && <span className="item-content mt-1">Market</span>}
          </div>
        </li>

        <li
          className={classNames("menu-item wt-nav-own-strategy", {
            active: active.startsWith(STRATEGY_V2_PATH),
            "sidebar-menu-disabled": hasFreeOrCore(),
          })}
          onClick={!hasFreeOrCore() ? handleNavigateToStrategyList : undefined}
        >
          <div
            className="inner-item"
            tabIndex={4}
            role="button"
            onClick={hasFreeOrCore() ? togglePurchasePlanModal : undefined}
          >
            <span className="icon-wrapper create-spacing">
              <span className="icon">
                {!collapsed ? (
                  <CreateStrategiesIcon
                    className="create-strategy"
                    stroke={
                      active.startsWith(STRATEGY_V2_PATH)
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip value="Create Strategy">
                    <CreateStrategiesIcon
                      fill={
                        active.startsWith(STRATEGY_V2_PATH)
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && (
              <span className="item-content ">
                Create
                {hasFreeOrCore() && (
                  <IconLock
                    className="sidebar-lock-icon"
                    title="Upgrade to premium to access Create"
                  />
                )}
              </span>
            )}
          </div>
        </li>

        <li
          className={classNames("menu-item", {
            active: active.startsWith(MARKET_V2_PATH),
          })}
          onClick={handleNavigateToStockSearch}
        >
          {/* <div className="inner-item" tabIndex={5} role="button">
            <span className="icon-wrapper">
              <span className="icon">
                {!collapsed ? (
                  <SearchIcon2
                    fill={
                      active.startsWith(MARKET_V2_PATH)
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip tooltipValue="Legacy Markets">
                    <SearchIcon2
                      fill={
                        active.startsWith(MARKET_V2_PATH)
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && <span className="item-content">Legacy Markets</span>}
          </div> */}
        </li>

        <li
          className={classNames("menu-item", {
            active: active.startsWith(RESEARCH_PATH),
          })}
          onClick={handleNavigateToResearch}
        >
          <div className="inner-item" tabIndex={6} role="button">
            <span className="icon-wrapper">
              <span className="icon">
                {!collapsed ? (
                  <SidebarResearchIcon
                    stroke={
                      active.startsWith(RESEARCH_PATH)
                        ? theme.aside.icon.primary
                        : theme.aside.icon.secondary
                    }
                  />
                ) : (
                  <Tooltip tooltipValue="Research">
                    <SidebarResearchIcon
                      stroke={
                        active.startsWith(RESEARCH_PATH)
                          ? theme.aside.icon.primary
                          : theme.aside.icon.secondary
                      }
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            {!collapsed && <span className="item-content">Research</span>}
          </div>
        </li>

        {/* Choose Plan Modal for locked sidebar items */}
        <ChoosePlanModal
          show={showPurchasePlanModal}
          onHide={togglePurchasePlanModal}
        />
      </ul>

      {/* Snaptrade Modal */}
      {showSnaptradeModal && (
        <MultiStepModal
          show={showSnaptradeModal}
          onHide={toggleSnaptradeModal}
          onSuccess={() => {
            refetch();
            toggleSnaptradeModal();
          }}
        />
      )}
    </AppMenuContainer>
  );
};

AppMenu.propTypes = {
  active: PropTypes.string,
};
